import { configureStore } from '@reduxjs/toolkit';

import themeReducer from './slice/themeSlice';
import userReducer from './slice/userSlice';
import ordersReducer from './slice/ordersSlice';


export const store = configureStore({
    reducer: {
        theme: themeReducer,
        user: userReducer,
        orders: ordersReducer,
    }
}); 